module.exports = __webpack_public_path__ + "static/img/5.1655d10.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/service/imgs/5.png
// module id = BnEB
// module chunks = 1